import React, { FC, useEffect, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { useNationalTeamsQuery } from '../../api';
import { NationalTeamsFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import { revealTeams } from '../../utils/revealTeams';
import moment from 'moment';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const [nationalTeams, setNationalTeams] = useState<any>([]);
  const { push } = useHistory();
  const access = usePermission('directory', 'classifiers');
  const { data } = useNationalTeamsQuery({
    variables: { skip: page, first: PER_PAGE, filter },
    fetchPolicy: 'no-cache',
  });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'info',
      label: 'Реестровый номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (info) => {
          const { id, registryNumber } = info || {};
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/national_team/${id}`}
                >
                  {registryNumber}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'dirRegion',
      label: 'Регион',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (region) => <React.Fragment>{region.fullName}</React.Fragment>,
      },
    },
    {
      name: 'sportTypeEndDisciplinesGroups',
      label: 'Вид спорта/группа дисциплин',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'athleteGroups',
      label: 'Кол-во спортсменов',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (group) => (
          <React.Fragment>
            {group.reduce((acc: number, current: any) => acc + current.athletes.length, 0)}
          </React.Fragment>
        ),
      },
    },
    {
      name: 'dirSportingEvent',
      label: 'Реестровый номер мероприятия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (event) => <React.Fragment>{event.registryNumber}</React.Fragment>,
      },
    },
    {
      name: 'dirSportingEvent',
      label: 'Название мероприятия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (event) => <React.Fragment>{event.name}</React.Fragment>,
      },
    },
    {
      name: 'dirSportingEvent',
      label: 'период проведения',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (event) => (
          <React.Fragment>{`${event.startDate && moment(event.startDate).format('DD.MM.YY')} - ${
            event.endDate && moment(event.endDate).format('DD.MM.YY')
          }`}</React.Fragment>
        ),
      },
    },
    {
      name: 'status',
      label: 'статус согласования',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (status) => <React.Fragment>{status.name}</React.Fragment>,
      },
    },
  ];

  useEffect(() => {
    setNationalTeams(revealTeams(data?.dirNationalTeams || []));
  }, [page, data]);

  return (
    <MainTemplate pageName="Справочник сборных команд" url="">
      <NationalTeamsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Справочник сборных команд</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/national_team/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={nationalTeams || []}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count: data && data.count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
